RegistrationEditCtrl = ($scope, $filter, $translate, $location, flash, account, RegistrationService, AccountService, confirmationStatus) ->
  $scope.account = account
  $scope.originalEmail = account.email
  $scope.defaultData = RegistrationService.getDefaultData()
  $scope.isSubmitting = false
  $scope.isShowEmailInput = false
  $scope.passwordPattern = /^(?=.{10,}$)((?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*\d))|(?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*[!"#$%&'()*+,\-\.\ /:;<=>?@\[\\\]^_`{|}~]))|(?=(?:.*[a-z]))(?=(?:.*\d))(?=(?:.*[!"#$%&'()*+,\-\.\ /:;<=>?@\[\\\]^_`{|}~]))|(?=(?:.*[A-Z]))(?=(?:.*\d))(?=(?:.*[!"#$%&'()*+,\-\.\ /:;<=>?@\[\\\]^_`{|}~])))[A-Za-z\d!"#$%&'()*+,\-\.\ /:;<=>?@\[\\\]^_`{|}~]+$/

  $scope.confirmationStatus = confirmationStatus

  $scope.submit = (account) ->
    $scope.isSubmitting = true
    RegistrationService.update(account).then (resp) ->
      flash.success $filter('translate')('API_SUCCESS')
      $scope.$emit "accountUpdated.gnp.AccountService"
    .catch (resp) ->
      if resp.data?.code is 'error.email_already_taken'
        flash.error $filter('translate')('EMAIL_DUPLICATED')
      else if resp.data?.code is 'error.current_password_wrong'
        flash.error $filter('translate')('CURRENT_PASSWORD_ERROR')
      else
        flash.error $filter('translate')('API_ERROR')
    .finally ->
      $scope.isSubmitting = false

  $scope.showEmailInput = ->
    $scope.isShowEmailInput = true
    false

RegistrationEditCtrl['$inject'] = [
  '$scope'
  '$filter'
  '$translate'
  '$location'
  'flash'
  'account'
  'RegistrationService'
  'AccountService'
  'confirmationStatus'
]

module.exports = RegistrationEditCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/registration/edit-controller.coffee